<template>
	<section>
		<!--工具条  v-model="filterFlagSwitch" v-model="filterDataTypeSwitch" -->
		<el-col  :span="24" class="toolbar" style="padding-bottom: 10px;">
			<div :disabled="userRoleIdentity == 'level-untrue'" style="float:right;" >
				<el-switch @change="changeFilterFlagSwitch"  v-model="flagSwitch"></el-switch>
				<div style="display:inline;padding-right:20px;font-size: 13px;">仅显示未读</div>
				<el-switch @change="changeFilterDataTypeSwitch"  v-model="dataTypeSwitch" ></el-switch>
				<div  style="display:inline;padding-right:20px;font-size: 13px;">仅显示报警</div>
			</div>
			<el-tabs v-model="sysSourceOptName" @tab-click="tabHandleClick">
				<!-- <el-tab-pane label="全部" name="all"></el-tab-pane> -->
				<el-tab-pane v-for="i in sysSourceList" :label="i.name" :value="i.code"></el-tab-pane>
			</el-tabs>
			<!-- <label v-if="sysSourceOptName == 'all'" style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">系统类型:</label> -->
			<!-- <el-select :disabled="userRoleIdentity == 'level-untrue'" v-if="sysSourceOptName == 'all'" v-model="sysSourceOpt" placeholder="全部" style="width: 140px">
				<el-option label="全部" value="all"></el-option>
				<el-option v-for="i in sysSourceList" :label="i.name" :value="i.code"></el-option>
            </el-select> -->
			
			<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">项目归属:</label>
			 <el-input :disabled="userRoleIdentity == 'level-untrue'" placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 140px" @focus="showProjectTree" v-model="projectNames"></el-input>
			 			
			<el-dialog :disabled="userRoleIdentity == 'level-untrue'" title="项目归属" v-model="projectTreeDialogVisible" >
              <div style="">
				<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
				<el-tree class="filter-tree" :data="projectTree" show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
			  </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="projectTreeOnCancel">取 消</el-button>
                <el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
              </div>
            </el-dialog>
			<label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">时间:</label>
			<div style="display:inline;">
				<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="startMonth" value-format="yyyyMM"  format="yyyyMM" type="month" :placeholder="startMonthValue" @change="startMonthOnChange"></el-date-picker>
				<label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
				<el-date-picker :disabled="userRoleIdentity == 'level-untrue'" style="width:120px;" v-model="endMonth" value-format="yyyyMM" format="yyyyMM" type="month"  :placeholder="endMonthValue" @change="endMonthOnChange"></el-date-picker>
			</div>
			<el-button :disabled="userRoleIdentity == 'level-untrue'" @click="queryBtn()">查询</el-button>
			<el-button :disabled="userRoleIdentity == 'level-untrue'" @click="exportData()" style="float:right;margin-top: 0px;">数据导出</el-button>
			<el-button :disabled="userRoleIdentity == 'level-untrue'" v-if="userRoleIdentity == 'admin'" @click="fileAlarmBatch()" style="float:right;margin-top: 0px;">归档</el-button>
			<el-button :disabled="userRoleIdentity == 'level-untrue'" @click="signReadedBatch()" style="float:right;margin-top: 0px;">确认已读</el-button>
		</el-col>

		<!--列表" -->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading"  style="width: 100%;" @selection-change="selsChange" :row-style="setTableRowStyle">
			<el-table-column  type="selection" width="50" >
			</el-table-column>
			<el-table-column prop="projectName" label="所属项目" width="130" sortable>
				<template slot-scope="scope">
					<el-badge v-if="scope.row.flag == '0'" is-dot class="item"><span> </span></el-badge>
					<i v-if="scope.row.timeOutFlag == '1'" class="el-icon-time" style="color:#929292"></i>
					<!-- <el-badge v-if="scope.row.flag == '0'" is-dot class="item"><span style="margin-left: 2px">{{ scope.row.projectName }}</span> -->
					<span  style="margin-left: 5px">{{ scope.row.projectName }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="appSourceName" label="系统类型" width="100"  sortable>
			</el-table-column>
			<el-table-column v-if="sysSourceTabSelected =='BA' || sysSourceTabSelected =='FAS'" prop="deviceName" label="点名称" width="100" sortable>
			</el-table-column>
			<el-table-column v-else prop="deviceName" label="传感器名称" width="100" sortable>
			</el-table-column>
			<el-table-column v-if="sysSourceTabSelected =='BA' || sysSourceTabSelected =='FAS'" prop="deviceAddress" label="点地址" width="120" sortable>
			</el-table-column>
			<el-table-column v-else prop="deviceAddress" label="传感器地址" width="120" sortable>
			</el-table-column>
			<el-table-column prop="alarmContent" label="告警内容" min-width="140" sortable>
			</el-table-column>
			<el-table-column prop="alarmTime" label="告警时间" min-width="130" sortable>
			</el-table-column>
			<el-table-column prop="takeTimes" label="时长" min-width="100" sortable>
			</el-table-column>
			<el-table-column   prop="dataTypeName" label="告警类型" min-width="80" sortable>
				<template slot-scope="scope">
                  <span v-if="scope.row.dataType===-1"  >{{scope.row.dataTypeName}}</span>
				  <span style="color:#E30613;" v-else>{{scope.row.dataTypeName}}</span>
	              </template>
			</el-table-column>
			<el-table-column v-if="userRoleIdentity == 'admin'" label="操作" width="100">
				<template scope="scope">
					<el-button  size="small" @click="updateAlarmState(scope.$index, scope.row)">归档</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>
<style>
.item {margin-right: 6px;}
</style>
<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import global from '@/config/global_config'
	import Vue from 'vue'

	export default {
		watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
		data() {
			return {
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				sysSourceOptName:'',
				sysSourceList:[],
				sysSourceOpt:'',
				sysSourceTabSelected:'',
				projectTree:[],
				projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectTreeCheckedKeys:[],
				startMonth: '',
				endMonth:'',
				startMonthValue:tools.getCurrentYear()+'01',
				endMonthValue:tools.getCurrentYear()+'12',
				projectIds:'',
				projectNames:'',
				userRoleIdentity:global.getCurrentUser().roleIdentity,
				filterFlagSwitch:null,
				filterDataTypeSwitch:null,
				flagSwitch:0,
				dataTypeSwitch:0,
				tableSelectionIds:''
			}
		},
		methods: {
			setTableRowStyle(row,rowIndex){
				// if(row.flag == 0){
				// 	return 'background-color: #d0d0d0';
				// }
				// else if(row.flag == 1){
				// 	return 'background-color: #ffffff';
				// }
			},
			tabHandleClick(tab, event) {
				this.sysSourceTabSelected = this.sysSourceList[tab.index].code;
				this.get_list_data()
			},
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			startMonthOnChange(val) {  
				this.startMonthValue = val;  
			},
			endMonthOnChange(val) {  
				this.endMonthValue = val;
			},
			get_list_data() {
				if(this.sysSourceOpt == 'all') this.sysSourceOpt = '';
				let appSourceCodes = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
				
				let param = {
					pageNum: this.page,
					appSourceCodes:appSourceCodes,
					projectIds:this.projectIds,
					pageSize:15,
					startYm:this.startMonthValue,
					endYm:this.endMonthValue
				};
				if(null != this.filterFlagSwitch) param.flag = this.filterFlagSwitch;
				if(null != this.filterDataTypeSwitch) param.dataType = this.filterDataTypeSwitch;
				this.listLoading = true;
				api.currentAlarm_list_request(param).then((res) => {
					this.total = res.data.total;
					if (res.data.list) {
						this.list_data = res.data.list;           
					}
					this.listLoading = false;
			    }).catch(function (e) {
					tools.error(new Vue(),e.message);
                });
			},
			updateAlarmState: function (index, row) {
				this.listLoading = true;
				this.$confirm('确认归档该告警吗?', '提示',{showClose:false}).then(() => {
					let param = { ids: row.id };
					api.currentAlarm_updateAlarmState_request(param).then((res) => {
						tools.success(this,"归档成功");
						this.get_list_data();				
				    }).catch(function (e) {
						if(e.message)tools.error(new Vue(),e.message);
                    });
				})
				this.listLoading = false;
			},
			updateAlarmRead: function (index, row) {
				this.listLoading = true;
				let param = { ids: row.id };
					api.currentAlarm_updateAlarmRead_request(param).then((res) => {
						tools.success(this,"操作成功");
						this.get_list_data();				
				    }).catch(function (e) {
						if(e.message)tools.error(new Vue(),e.message);
                    });
				this.listLoading = false;
			},
			getSysSourceList: function () {
				let param = {};
				this.listLoading = true;
				api.system_getSysSourceList_request(param).then((res) => {
					this.sysSourceList = res.data;
					this.sysSourceTabSelected = this.sysSourceList[0].code;	
					this.get_list_data();
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
					let temp = [];
					let checkedTemp =[];
					 for (let index = 0; index < res.data.length; index++) {
						checkedTemp.push(res.data[index].groupId);
						temp[index] = {id:res.data[index].groupId ,label:res.data[index].groupName,children:[]};
						res.data[index].projectList.forEach(one => {
							checkedTemp.push(one.projectId);
							temp[index].children.push({id:one.projectId,label:one.projectName});
						});
					}
					console.log(temp);
					this.projectTree = temp;
					//this.projectTreeDefaultChecked = checkedTemp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
			},
			selsChange: function (sels) {
				this.sels = sels;
				this.tableSelectionIds = "";
				this.sels.forEach(one => {
					if(this.tableSelectionIds.length == 0){
						this.tableSelectionIds = one.id;
					}
					else
					this.tableSelectionIds = this.tableSelectionIds +","+one.id;
				})
			},
			queryBtn(){
				if(!this.startMonthValue){tools.error(this,'请选择开始月份');return false};
				if(!this.endMonthValue){tools.error(this,'请选择结束月份');return false};
				this.get_list_data();
			},
			exportData:function () {
				let appSourceCodes = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
				let param = {
					appSourceCodes:appSourceCodes,
					projectIds:this.projectIds,
					startYm:this.startMonthValue,
					endYm:this.endMonthValue
				};
				this.listLoading = true;
				api.currentAlarm_exportCurrentAlarmList_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'currentAlarmList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch(function (e) {
					console.log(e);
					tools.error(new Vue(),e.message);
                });
				this.listLoading = false;
			},
			fileAlarmBatch: function () {
				if(this.tableSelectionIds.length == 0){
					tools.error(this,"请先选择告警");
					return
				} 
				let param = {ids:this.tableSelectionIds};
				api.currentAlarm_updateAlarmState_request(param).then((res) => {
					tools.success(this,"归档成功");
					// setTimeout( "window.location.reload()",2000);
					this.get_list_data();				
				}).catch(function (e) {
					if(e.message)tools.error(new Vue(),e.message);
				});
			},
			signReadedBatch: function () {
				if(this.tableSelectionIds.length == 0){
					tools.error(this,"请先选择告警");
					return
				} 
				let param = {ids:this.tableSelectionIds};
					api.currentAlarm_updateAlarmRead_request(param).then((res) => {
						tools.success(this,"标记已读成功");
						this.get_list_data();
				    }).catch(function (e) {
						if(e.message)tools.error(new Vue(),e.message);
                    });
			},
			changeFilterFlagSwitch: function (newStatus) {
				console.log(newStatus);
				status = Number(newStatus);
				if(status == 0)this.filterFlagSwitch =null;
				else if(status == 1)this.filterFlagSwitch =0;
				this.get_list_data();
			},
			changeFilterDataTypeSwitch: function (newStatus) {
				console.log(newStatus);
				status = Number(newStatus);
				if(status == 0)this.filterDataTypeSwitch =null;
				else if(status == 1)this.filterDataTypeSwitch =0;
				this.get_list_data();
			}
		},
		mounted() {
			this.getSysSourceList();
			this.getProjectTree();
		}
	}

</script>



// WEBPACK FOOTER //
// current_alarm_list.vue?1ba6461a